import { getBrandTheme } from "../styles/brandTheme";
import bouttimeLogo from "../assets/bouttime-logo.svg";

const ChevronLeft = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M15 18l-6-6 6-6" />
  </svg>
);

const SECTIONS = [
  {
    title: "1. Acceptance of Terms",
    body: "By creating an account and using BoutTime (“the App”), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the App.",
  },
  {
    title: "2. About BoutTime",
    body: "BoutTime is a nutrition and meal planning application designed to help users build sustainable healthy eating habits. The App provides tools for meal planning, recipe browsing, nutrition tracking, and goal setting.",
  },
  {
    title: "3. Eligibility",
    body: "You must be at least 18 years old to use BoutTime. By using the App you confirm that you meet this requirement.",
  },
  {
    title: "4. Your Account",
    body: "You are responsible for maintaining the confidentiality of your account credentials. You are responsible for all activity that occurs under your account. Please notify us immediately at hello@bouttime.app if you suspect unauthorised access to your account.",
  },
  {
    title: "5. Health Disclaimer",
    body: "BoutTime provides general nutrition information and meal planning tools for informational purposes only. The App is not a substitute for professional medical or nutritional advice. Always consult a qualified healthcare provider before making significant changes to your diet, especially if you have a medical condition. The nutrition targets calculated by the App are estimates based on general formulas and may not be appropriate for everyone.",
  },
  {
    title: "6. Your Content",
    body: "Any recipes, notes, or other content you create within the App remain yours. You grant BoutTime a limited licence to store and display this content to provide the service to you. We do not claim ownership of your content.",
  },
  {
    title: "7. Acceptable Use",
    body: "You agree not to misuse the App, attempt to access other users' accounts, reverse engineer the App, or use the App for any unlawful purpose.",
  },
  {
    title: "8. Service Availability",
    body: "BoutTime is provided on an “as is” basis. We do not guarantee uninterrupted access to the App and reserve the right to modify, suspend, or discontinue the service at any time with reasonable notice where possible.",
  },
  {
    title: "9. Intellectual Property",
    body: "All content within the App including recipes, design, logos, and branding is owned by BoutTime unless otherwise stated. You may not reproduce or distribute this content without permission.",
  },
  {
    title: "10. Termination",
    body: "You may delete your account at any time from within the App settings. We reserve the right to suspend or terminate accounts that violate these terms.",
  },
  {
    title: "11. Limitation of Liability",
    body: "To the fullest extent permitted by law, BoutTime shall not be liable for any indirect, incidental, or consequential damages arising from your use of the App.",
  },
  {
    title: "12. Changes to These Terms",
    body: "We may update these Terms from time to time. We will notify you of significant changes via the App or by email. Continued use of the App after changes constitutes acceptance of the new terms.",
  },
  {
    title: "13. Governing Law",
    body: "These Terms are governed by the laws of England and Wales.",
  },
  {
    title: "14. Contact",
    body: "For any questions about these Terms please contact us at hello@bouttime.app",
  },
];

export default function TermsPage() {
  const appTheme = getBrandTheme();

  return (
    <div style={{
      minHeight: "100vh",
      background: appTheme.pageBackground,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    }}>
      {/* Sticky header */}
      <div style={{
        width: "100%",
        position: "sticky",
        top: 0,
        background: appTheme.pageBackground,
        zIndex: 10,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px 24px",
        borderBottom: `1px solid rgba(27,67,50,0.08)`,
      }}>
        <button
          onClick={() => window.close()}
          style={{
            position: "absolute",
            left: "16px",
            background: "none",
            border: "none",
            cursor: "pointer",
            color: appTheme.primaryText,
            padding: "8px",
            display: "flex",
            alignItems: "center",
            touchAction: "manipulation",
          }}
        >
          <ChevronLeft />
        </button>
        <img src={bouttimeLogo} alt="BoutTime" style={{ height: "28px", width: "auto" }} />
      </div>

      {/* Scrollable content */}
      <div style={{
        width: "100%",
        maxWidth: "680px",
        padding: "40px 24px 80px",
        boxSizing: "border-box",
      }}>
        <p style={{
          fontFamily: appTheme.fontBody,
          fontSize: "13px",
          color: appTheme.mutedText,
          marginBottom: "8px",
        }}>
          Last updated: May 2026
        </p>
        <h1 style={{
          fontFamily: appTheme.fontHeading,
          fontSize: "32px",
          fontWeight: "600",
          color: appTheme.primaryText,
          margin: "0 0 40px",
          lineHeight: 1.2,
        }}>
          Terms of Service
        </h1>

        {SECTIONS.map(({ title, body }) => (
          <div key={title} style={{ marginBottom: "32px" }}>
            <h2 style={{
              fontFamily: appTheme.fontHeading,
              fontSize: "18px",
              fontWeight: "600",
              color: appTheme.primaryText,
              margin: "0 0 10px",
            }}>
              {title}
            </h2>
            <p style={{
              fontFamily: appTheme.fontBody,
              fontSize: "15px",
              color: appTheme.secondaryText,
              margin: 0,
              lineHeight: 1.7,
            }}>
              {body}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
